"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var isDisabled = props.isDisabled,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$isChecked = props.isChecked,
    isChecked = _props$isChecked === void 0 ? false : _props$isChecked;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors,
    direction = _useContext.direction;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccToggleSwitchStyle = (0, _react.useMemo)(function () {
    var _input;
    var disabledProps = function disabledProps() {
      if (isDisabled) {
        return {
          opacity: '.5',
          pointerEvents: 'none',
          cursor: 'default'
        };
      }
      return {};
    };
    var deviceProps = function deviceProps() {
      var height = isMobileView ? pxToRem(20) : pxToRem(16);
      var width = isMobileView ? pxToRem(34) : pxToRem(26);
      return {
        width: width,
        height: height
      };
    };
    var getSliderWidth = function getSliderWidth() {
      var isOppositeDirection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var sign = isOppositeDirection ? -1 : 1;
      var width = isMobileView ? pxToRem(sign * 14) : pxToRem(sign * 10);
      return width;
    };
    var toggleSwitchSliderThumbSizeProps = function toggleSwitchSliderThumbSizeProps() {
      var width = getSliderWidth();
      var height = width;
      var bottom = pxToRem(3);
      var right;
      var left;
      if (direction === 'rtl') {
        right = pxToRem(3);
        left = 'auto';
      } else {
        left = pxToRem(3);
        right = 'auto';
      }
      return {
        width: width,
        height: height,
        bottom: bottom,
        left: left,
        right: right
      };
    };
    var toggleSwitchCheckedColorProps = function toggleSwitchCheckedColorProps() {
      if (isChecked) {
        var background = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark;
        return {
          background: background
        };
      }
      return {};
    };
    var ccToggleSwitchSlider = (0, _css.css)(_objectSpread({
      position: 'absolute',
      cursor: 'pointer',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border,
      transition: '.4s',
      borderRadius: pxToRem(25)
    }, disabledProps()));
    var ccToggleSwitchSliderThumb = (0, _css.css)(_objectSpread({
      position: 'absolute',
      content: '""',
      backgroundColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
      transition: '.4s',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, toggleSwitchSliderThumbSizeProps()));
    var ccToggleSwitchSliderThumbIcon = (0, _css.css)({
      display: 'flex',
      justifyContent: 'center'
    });
    var ccToggleSwitch = (0, _css.css)(_objectSpread(_objectSpread({
      position: 'relative',
      display: 'inline-block'
    }, deviceProps()), {}, {
      input: (_input = {
        opacity: 0,
        width: 0,
        height: 0
      }, _defineProperty(_input, '&:checked + .' + ccToggleSwitchSlider, _objectSpread({}, toggleSwitchCheckedColorProps())), _defineProperty(_input, '&:checked + .' + ccToggleSwitchSlider + ' .' + ccToggleSwitchSliderThumb, {
        transform: "translateX(".concat(direction === 'rtl' ? getSliderWidth(true) : getSliderWidth(), ")")
      }), _input)
    }));
    return {
      ccToggleSwitch: ccToggleSwitch,
      ccToggleSwitchSlider: ccToggleSwitchSlider,
      ccToggleSwitchSliderThumb: ccToggleSwitchSliderThumb,
      ccToggleSwitchSliderThumbIcon: ccToggleSwitchSliderThumbIcon
    };
  }, [color, direction, isChecked, isDisabled, isMobileView, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-ToggleSwitch': ccToggleSwitchStyle.ccToggleSwitch,
    'cc-ToggleSwitch__slider': ccToggleSwitchStyle.ccToggleSwitchSlider,
    'cc-ToggleSwitch__slider-thumb': ccToggleSwitchStyle.ccToggleSwitchSliderThumb,
    'cc-ToggleSwitch__slider-thumb-icon': ccToggleSwitchStyle.ccToggleSwitchSliderThumbIcon
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;